module.exports = __webpack_public_path__ + "static/media/previewImg.f24bf724.svg";